import { render } from "./EditInstitute.vue?vue&type=template&id=3fc4da52&scoped=true"
import script from "./EditInstitute.vue?vue&type=script&lang=js"
export * from "./EditInstitute.vue?vue&type=script&lang=js"

import "./EditInstitute.vue?vue&type=style&index=0&id=3fc4da52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc4da52"]])

export default __exports__